/* 321 Cookie - one-tap add buttons (site audit 2026-09-21)
   Theme ASSET. Loaded by snippets/press-upsell.liquid and sections/seasonal-picks.liquid.

   Any <button data-mini-add> with data-variant adds one of that variant via
   /cart/add.js. Ready-made designs also carry data-design-id / data-design-url /
   data-design-title, sent as the same line properties cookie-buy.js and
   quick-add.liquid use (_design_id / _design_url / Design) - the Beast poller
   only prints lines that carry _design_id.

   After a verified add it fires Horizon's 'cart:update' event exactly like
   cookie-buy.js (detail.data.itemCount = cart.item_count, source not
   'product-form-component', so cart-icon.js SETS the bubble count).
   data-reload="1" reloads the page instead (used on /cart, so the new line and
   totals render server-side).

   Contains NO Liquid - keep it that way or it cannot live in /assets.
*/
(function () {
  'use strict';
  if (window.__cookieMiniAdd) return;
  window.__cookieMiniAdd = true;

  function announceCart(cart) {
    try {
      if (!cart || typeof cart.item_count !== 'number') return;
      var ev;
      try { ev = new Event('cart:update', { bubbles: true }); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent('cart:update', true, false); }
      ev.detail = { resource: cart, sourceId: 'mini-add',
                    data: { source: 'mini-add', itemCount: cart.item_count } };
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function status(btn, msg) {
    var box = btn.closest('[data-mini-add-scope]');
    var el = box && box.querySelector('[data-mini-add-status]');
    if (el) el.textContent = msg || '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-mini-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var vid = Number(btn.getAttribute('data-variant'));
    if (!vid) return;
    var item = { id: vid, quantity: 1 };
    var did = btn.getAttribute('data-design-id');
    if (did) {
      item.properties = { '_design_id': did,
                          '_design_url': btn.getAttribute('data-design-url') || '',
                          'Design': btn.getAttribute('data-design-title') || did };
    }
    var label = btn.innerHTML;
    btn.disabled = true;
    status(btn, 'Adding…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add it.');
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      if (btn.getAttribute('data-reload') === '1') { window.location.reload(); return; }
      announceCart(cart);
      btn.innerHTML = btn.getAttribute('data-added-label') || 'Added &#10003;';
      btn.classList.add('is-added');
      status(btn, '');
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.innerHTML = label;
      status(btn, (err && err.message) || 'Network error - please try again.');
    });
  });
})();
